import { api } from '../../core/network/api';

/**
 * design/gdd/economy-currency.md REST surface — plain wrappers around the
 * template's shared `api` client (JWT cookie + auto-refresh handled there).
 * No Sconce-Hub-specific transformation of any response (sconce-hub.md
 * Core Rule #2 / AC #6).
 */

export interface Balance {
  soft: number;
  premium: number;
  stashCapacity: number;
  stashUsed: number;
}

export const getBalance = (): Promise<Balance> => api.get('/economy/balance');

export const sellItem = (stashItemId: string): Promise<{ soldItemDefId: string; price: number; softBalance: number }> =>
  api.post('/economy/vendor/sell', { stashItemId });

export const expandStash = (): Promise<{ stashCapacity: number; cost: number; softBalance: number }> =>
  api.post('/economy/stash/expand');

export interface WaxBundleRow {
  id: string;
  name: string;
  priceEmber: number;
  wax: number;
}

export interface WaxShelf {
  bundles: WaxBundleRow[];
  exchangeRate: number;
  dailyCapPremium: number;
  spentToday: number;
  remainingToday: number;
}

export const getWaxBundles = (): Promise<WaxShelf> => api.get('/economy/wax/bundles');

export const purchaseWaxBundle = (bundleId: string): Promise<{
  bundleId: string; emberSpent: number; waxCredited: number; softBalance: number;
}> => api.post('/economy/wax/purchase', { bundleId });
